import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=19087c60&scoped=true"
import script from "./AppNavItem.vue?vue&type=script&lang=js"
export * from "./AppNavItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=19087c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19087c60",
  null
  
)

export default component.exports